import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    blogs: PropTypes.array,
  },
  render() {
    if (this.props.blogs.length === 0) {
      return "";
    }
    const blogs = this.props.blogs.map(function(blog) {
      return (
        <div className="background-white mt10 pd10" key={blog.id}>
          <a href={`/blogs/${blog.id_to_param}`}>
            <p className="bold line-1">{blog.title}</p>
            <p className="mb0 small line-1">
              {blog.publish_date_disp}&nbsp;&nbsp;{blog.circle.name}
            </p>
          </a>
        </div>
      );
    });
    return (
      <div>
        <article className="timeline-box">
          <h2 className="left">
            <i className="fas fa-newspaper" />&nbsp;最近のブログ
          </h2>
          {blogs}
        </article>
      </div>
    );
  },
});
